import { Region } from '../enums/Region'

export function useRegion() {

    return {
        region: process.env.VUE_APP_REGION as Region
    }

}
